// eslint-disable-next-line jira/import-whitelist
import GADGETS_DEFINITION, {
	type ReactGadgetIdentity,
	type ReactGadgetsState,
	type ReactKey,
} from '@atlassian/jira-react-gadgets-definition/src/main.tsx';
import type { ResourceStoreContext } from '@atlassian/react-resource-router';

const preloadGadgetBundles = (reactKeys: ReactKey[]): void =>
	reactKeys.forEach((reactKey) => {
		GADGETS_DEFINITION[reactKey].preload();
	});

export const loadReactGadgets = async (
	gadgets: ReactGadgetIdentity[],
	storeContext: ResourceStoreContext,
): Promise<ReactGadgetsState> => {
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	const distinctReactKeys = [...new Set(gadgets.map((gadget) => gadget.reactKey))] as ReactKey[];
	preloadGadgetBundles(distinctReactKeys);

	return Object.fromEntries(
		await Promise.all(
			gadgets.map(({ id, reactKey, userPrefs }) =>
				// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
				GADGETS_DEFINITION[reactKey as ReactKey]
					?.getInitialState(storeContext, userPrefs?.fields || [])
					.then(
						(state) => [id, state],
						(error) => [id, error],
					),
			),
		),
	);
};
